// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E2nA","icon":"styles_icon__FFMQD"};